/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_TitleInputs */

const en_wc_tut_title = /** @type {(inputs: Wc_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft tutorial`)
};

/**
* | output |
* | --- |
* | "WordCraft tutorial" |
*
* @param {Wc_Tut_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_title = /** @type {((inputs?: Wc_Tut_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_title(inputs)
});
export { wc_tut_title as "wc.tut.title" }